// extracted by mini-css-extract-plugin
module.exports = {"content":"ProcesosItem_content__17IBA","info":"ProcesosItem_info__2T_jI","image":"ProcesosItem_image__1-CFj"};